import { UserDetails } from "../store/userSlice";

export function getPostLoginPath(user: Partial<UserDetails> | undefined) {
    return user?.isAdmin ? "/Admin/billing" : "/profile";
}
